import React from 'react';

import NextEnv from '@tb-core/helpers/next-env';
import { Props } from '@tb-core/types';

export default function withNextConfig<T = Props>(Component: any) {
    return (props: T) => <Component {...NextEnv} {...props} />;
}
